module.exports = __webpack_public_path__ + "img/wedo02.33016e70.png";